import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { courseFloridaPermitStudyGuide } from 'dsoapi';

const FloridaPermitStudyGuide = ({ setTitle = () => {} }) => {
  const { uceId } = useParams();
  const [studyGuideData, setStudyGuideData] = useState({
    html: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await courseFloridaPermitStudyGuide(uceId);
        setStudyGuideData(response.data);
        setTitle('Florida Permit Study Guide');
      } catch (err) {
        console.error('Error fetching study guide:', err);
        setError('Failed to load study guide. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uceId, setTitle]);

  // Apply Semantic UI styling to tables after content is rendered
  useEffect(() => {
    if (contentRef.current) {
      const tables = contentRef.current.querySelectorAll('table');
      tables.forEach((table) => {
        // Add Semantic UI table classes
        table.classList.add('ui', 'table', 'striped', 'celled', 'fluid');
      });
    }
  }, [studyGuideData.html]);

  if (loading) {
    return (
      <div className="ui main container">
        <div className="ui segment">
          <div className="ui active centered inline loader"></div>
          <p style={{ textAlign: 'center', marginTop: '1rem' }}>
            Loading study guide...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ui main container">
        <div className="ui segment">
          <div className="ui negative message">
            <div className="header">Error</div>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ui main container">
      <div className="ui segment">
        <h1 className="ui center aligned header">Florida Permit Study Guide</h1>
        <div className="ui divider"></div>
        <div
          ref={contentRef}
          dangerouslySetInnerHTML={{ __html: studyGuideData.html }}
        />
        <div style={{ height: '20px' }}></div>
      </div>
    </div>
  );
};

export default FloridaPermitStudyGuide;
